import { createConsumer } from "@rails/actioncable";

const actionCableUrl = () => {
  return process.env.VUE_APP_ACTION_CABLE_URL || "ws://localhost:3000/cable";
};

const cable = createConsumer(actionCableUrl());

export { cable };
